module.exports = __webpack_public_path__ + "static/madame-figaro-couverture-1-d2e19291d3b4342d12125d05429ad7e2.jpg";